import React, { useState, useEffect } from 'react';
import styles from './index.module.less';
import { history } from 'app/history';
import { useNavigate } from 'react-router-dom';
import {
  Form,
  Button,
  Card,
  Row,
  Radio,
  Col,
  Select,
  Checkbox,
  DatePicker,
  Input,
  message
} from 'antd';
import moment from 'moment';
//import FormData from 'form-data';
import FormItem from 'common/FormItem';
import { useDispatch, useSelector } from 'react-redux';
import { submit_declaration, get_bu_master } from '../../welcome/redux/slice';

const CreateDeclarationFormPage = ({ declarationRecord }) => {
  console.log('declarationRecord222', declarationRecord);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const { submit_declarationLoading, buMasterList, get_bu_masterLoading } =
    useSelector((state) => state.dashboard);

  const [formValues, setFormValues] = useState({});

  useEffect(() => {
    dispatch(get_bu_master({ page: 1, per_page: 20 }));
  }, [dispatch]);

  // Get current financial year (April to March)
  const getCurrentFinancialYear = () => {
    const currentDate = moment();
    const currentMonth = currentDate.month(); // 0-11 (0 = January, 3 = April)
    const currentYear = currentDate.year();

    // Financial year starts from April (month 3)
    // If current month is April or later, FY is currentYear-nextYear
    // If current month is before April, FY is previousYear-currentYear
    if (currentMonth >= 3) {
      // April to December: FY 2025-26
      const nextYear = (currentYear + 1).toString().slice(-2);
      return `${currentYear}-${nextYear}`;
    } else {
      // January to March: FY 2024-25
      const prevYear = currentYear - 1;
      const currentYearShort = currentYear.toString().slice(-2);
      return `${prevYear}-${currentYearShort}`;
    }
  };

  const currentFinancialYear = getCurrentFinancialYear();

  // Auto-populate form fields from declarationRecord
  useEffect(() => {
    if (declarationRecord) {
      const currentDate = moment();

      // Extract values from declarationRecord
      const projectManagerName =
        declarationRecord?.ProjectSite?.Incharge?.givenName &&
        declarationRecord?.ProjectSite?.Incharge?.surname
          ? `${declarationRecord.ProjectSite.Incharge.givenName} ${declarationRecord.ProjectSite.Incharge.surname}`
          : declarationRecord?.ProjectSite?.Incharge?.givenName ||
            declarationRecord?.ProjectSite?.Incharge?.email ||
            undefined;

      const projectSiteName = declarationRecord?.ProjectSite?.name || undefined;
      const sbgName = declarationRecord?.Sbg?.name || undefined;
      const sbuName = declarationRecord?.Sbus?.name || undefined;
      // When BuMasterId is set, store BU id for payload; otherwise bu stays undefined for user selection
      const buValue =
        declarationRecord?.BuMasterId != null &&
        declarationRecord?.BuMasterId !== ''
          ? declarationRecord.BuMasterId
          : undefined;

      // Get declaration date or use current date
      const declarationDate = declarationRecord?.date
        ? moment(declarationRecord.date)
        : currentDate;

      // Get giftDeclaration value (isApplicable)
      const giftDeclaration = declarationRecord?.isApplicable;

      // Get checkbox values
      const confirmSiteDetails = declarationRecord?.checkbox1 || false;
      const confirmFinalDeclaration = declarationRecord?.checkbox2 || false;

      const initialValues = {
        giftDeclaration: giftDeclaration,
        projectManagerName: projectManagerName,
        projectSiteName: projectSiteName,
        declarationDate: declarationDate,
        sbg: sbgName,
        sbu: sbuName,
        bu: buValue,
        confirmSiteDetails: confirmSiteDetails,
        confirmFinalDeclaration: confirmFinalDeclaration
      };

      form.setFieldsValue(initialValues);
      setFormValues({
        giftDeclaration: giftDeclaration,
        projectManagerName: projectManagerName,
        projectSiteName: projectSiteName,
        declarationDate: declarationDate.format('YYYY-MM-DD'),
        sbg: sbgName,
        sbu: sbuName,
        bu: buValue,
        confirmSiteDetails: confirmSiteDetails,
        confirmFinalDeclaration: confirmFinalDeclaration
      });
    }
  }, [declarationRecord, form]);

  const hasBuMasterId =
    declarationRecord?.BuMasterId != null &&
    declarationRecord?.BuMasterId !== '';

  // BU options: when pre-populated from declarationRecord, ensure current BU is in list
  const buOptions = React.useMemo(() => {
    const list = buMasterList ?? [];
    if (
      hasBuMasterId &&
      declarationRecord?.BuMaster?.id &&
      !list.some((item) => item.id === declarationRecord.BuMaster.id)
    ) {
      return [
        {
          value: declarationRecord.BuMaster.id,
          label:
            declarationRecord.BuMaster.buName ?? declarationRecord.BuMaster.name
        },
        ...list.map((item) => ({
          value: item.id,
          label: item.buName ?? item.name
        }))
      ];
    }
    return list.map((item) => ({
      value: item.id,
      label: item.buName ?? item.name
    }));
  }, [buMasterList, hasBuMasterId, declarationRecord?.BuMaster]);

  const handleFormDataOnChange = (slug, value) => {
    console.log('slug,value', slug, value);

    if (slug === 'giftDeclaration' && value === true) {
      form.setFieldsValue({
        delegatorId: undefined
      });
    }
    if (slug === 'bu' && value && buMasterList?.length) {
      const selectedBu = buMasterList.find((item) => item.id === value);
      if (selectedBu) {
        const sbuName = selectedBu.Sbus?.name;
        const sbgName = selectedBu.Sbus?.Sbg?.name;
        form.setFieldsValue({ sbu: sbuName, sbg: sbgName });
        setFormValues((prev) => ({
          ...prev,
          [slug]: value,
          sbu: sbuName,
          sbg: sbgName
        }));
        return;
      }
    }
    setFormValues({
      ...formValues,
      [slug]: value
    });
  };

  const onFinish = async (values) => {
    console.log('values', values);

    if (!declarationRecord?.id) {
      message.error('Missing declaration configuration id.');
      return;
    }

    const payload = {
      id: declarationRecord.id,
      isApplicable: values.giftDeclaration === true,
      checkbox1: values.confirmSiteDetails || false,
      checkbox2: values.confirmFinalDeclaration || false,
      giftCount: values.giftCount || null,
      BuId: values.bu || declarationRecord?.BuMasterId
    };

    try {
      const response = await dispatch(submit_declaration(payload));
      if (response?.payload?.success) {
        navigate('/declaration-form');
      }
    } catch (error) {
      console.error('Error submitting declaration:', error);
    }
  };

  return (
    <div className={`${styles.container}`}>
      <div className={`${styles.title}`}>Gift Declaration</div>
      <div className={`${styles.subTitle}`}>
        Fill the gift declaration form given below
      </div>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        className={`${styles.formstyles}`}
        autoComplete="off"
      >
        <div style={{ marginTop: '30px', width: '100%', marginBottom: '20px' }}>
          <Card className={`${styles.cardStyles}`}>
            <>
              <div className={`${styles.card_content}`}>
                <FormItem
                  name="giftDeclaration"
                  label={
                    <div className={`${styles.card_title}`}>
                      Whether bulk gift declaration for Diwali{' '}
                      {declarationRecord?.fiscalYear || currentFinancialYear}{' '}
                      was applicable at my project site
                    </div>
                  }
                  rules={[
                    {
                      required: true,
                      message: 'This is a required field'
                    }
                  ]}
                  className={`${styles.select_styles}`}
                >
                  <Radio.Group
                    value={formValues?.giftDeclaration}
                    onChange={(e) =>
                      handleFormDataOnChange('giftDeclaration', e.target.value)
                    }
                    className={`${styles.card_Radio}`}
                  >
                    <Row className={`${styles.Radio_button_margin}`}>
                      <Col span={12}>
                        <Radio value={true}>Yes</Radio>
                      </Col>
                      <Col span={12}>
                        <Radio value={false}>No</Radio>
                      </Col>
                    </Row>
                  </Radio.Group>
                </FormItem>
              </div>

              {/* Conditional rendering when Yes is selected */}
              {formValues?.giftDeclaration === true && (
                <>
                  <div
                    style={{ marginTop: '20px' }}
                    className={`${styles.card_content} ${styles.declarationCheckboxWrapper}`}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: '12px',
                        flexWrap: 'wrap'
                      }}
                    >
                      <FormItem
                        name="confirmSiteDetails"
                        valuePropName="checked"
                        className={`${styles.select_styles}`}
                        style={{ marginBottom: 0 }}
                      >
                        <Checkbox
                          style={{ fontSize: '16px', color: '#344054' }}
                        >
                          I confirm that our site has correctly declared the
                          details of such gifts.
                        </Checkbox>
                      </FormItem>
                      <FormItem
                        name="giftCount"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter the number of gifts'
                          },
                          {
                            pattern: /^[0-9]+$/,
                            message: 'Please enter a valid number'
                          }
                        ]}
                        className={`${styles.select_styles}`}
                        style={{ marginBottom: 0 }}
                      >
                        <Input
                          type="number"
                          min={0}
                          placeholder="Enter number"
                          style={{
                            width: '120px',
                            height: '30px'
                          }}
                          onChange={(e) =>
                            handleFormDataOnChange('giftCount', e.target.value)
                          }
                        />
                      </FormItem>
                    </div>
                  </div>

                  <div
                    style={{ marginTop: '20px' }}
                    className={`${styles.card_content} ${styles.declarationCheckboxWrapper}`}
                  >
                    <FormItem
                      name="confirmFinalDeclaration"
                      valuePropName="checked"
                      rules={[
                        {
                          validator: (_, value) =>
                            value
                              ? Promise.resolve()
                              : Promise.reject(
                                  'Please confirm the final declaration'
                                )
                        }
                      ]}
                      className={`${styles.select_styles}`}
                    >
                      <Checkbox style={{ fontSize: '16px', color: '#344054' }}>
                        I hereby confirm that the number of gifts declared is
                        complete and final. Any subsequent updates or changes to
                        the declared gifts must be routed through the designated
                        approval channels on the Gift Register App, with full
                        responsibility assumed by me.
                      </Checkbox>
                    </FormItem>
                  </div>

                  <div
                    style={{ marginTop: '30px' }}
                    className={`${styles.card_content}`}
                  >
                    <Row gutter={[16, 16]}>
                      {/* Row 1: Project Manager Name, Project Site Name, Date */}
                      <Col xs={24} sm={24} md={8} lg={8}>
                        <FormItem
                          label={
                            <span className={`${styles.card_title}`}>
                              Project Manager Name
                            </span>
                          }
                          name="projectManagerName"
                          rules={[
                            {
                              required: false,
                              message: 'This is a required field'
                            }
                          ]}
                          className={`${styles.select_styles}`}
                        >
                          <Input
                            disabled
                            placeholder="Enter project manager name"
                            className={`${styles.margin_Top}`}
                            style={{ marginBottom: '15px' }}
                            onChange={(e) =>
                              handleFormDataOnChange(
                                'projectManagerName',
                                e.target.value
                              )
                            }
                          />
                        </FormItem>
                      </Col>
                      <Col xs={24} sm={24} md={8} lg={8}>
                        <FormItem
                          label={
                            <span className={`${styles.card_title}`}>
                              Project Site Name
                            </span>
                          }
                          name="projectSiteName"
                          rules={[
                            {
                              required: false,
                              message: 'This is a required field'
                            }
                          ]}
                          className={`${styles.select_styles}`}
                        >
                          <Input
                            disabled
                            placeholder="Enter project site name"
                            className={`${styles.margin_Top}`}
                            style={{ marginBottom: '15px' }}
                            onChange={(e) =>
                              handleFormDataOnChange(
                                'projectSiteName',
                                e.target.value
                              )
                            }
                          />
                        </FormItem>
                      </Col>
                      <Col xs={24} sm={24} md={8} lg={8}>
                        <FormItem
                          label={
                            <span className={`${styles.card_title}`}>Date</span>
                          }
                          name="declarationDate"
                          rules={[
                            {
                              required: false,
                              message: 'This is a required field'
                            }
                          ]}
                          // className={`${styles.date_styles}`}
                          className={`${styles.select_styles}`}
                        >
                          <DatePicker
                            disabled
                            placeholder="Select date"
                            style={{ width: '100%', marginBottom: '15px' }}
                            format="DD MMM YYYY"
                            onChange={(date) => {
                              const dateValue = date
                                ? date.format('YYYY-MM-DD')
                                : null;
                              handleFormDataOnChange(
                                'declarationDate',
                                dateValue
                              );
                            }}
                          />
                        </FormItem>
                      </Col>
                    </Row>
                    <Row gutter={[16, 16]}>
                      {/* Row 2: BU, SBU, SBG */}
                      <Col xs={24} sm={24} md={8} lg={8}>
                        <FormItem
                          label={
                            <span className={`${styles.card_title}`}>BU</span>
                          }
                          name="bu"
                          rules={[
                            {
                              required: false,
                              message: 'This is a required field'
                            }
                          ]}
                          className={`${styles.select_styles}`}
                        >
                          <Select
                            disabled={hasBuMasterId}
                            loading={get_bu_masterLoading}
                            showSearch
                            placeholder="Select BU"
                            className={`${styles.margin_Top}`}
                            style={{ marginBottom: '15px' }}
                            optionFilterProp="label"
                            filterOption={(input, option) =>
                              (option?.label ?? '')
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            options={buOptions}
                            onChange={(value) =>
                              handleFormDataOnChange('bu', value)
                            }
                          />
                        </FormItem>
                      </Col>
                      <Col xs={24} sm={24} md={8} lg={8}>
                        <FormItem
                          label={
                            <span className={`${styles.card_title}`}>SBU</span>
                          }
                          name="sbu"
                          rules={[
                            {
                              required: false,
                              message: 'This is a required field'
                            }
                          ]}
                          className={`${styles.select_styles}`}
                        >
                          <Input
                            disabled
                            placeholder="SBU (from selected BU)"
                            className={`${styles.margin_Top}`}
                            style={{ marginBottom: '15px' }}
                            onChange={(e) =>
                              handleFormDataOnChange('sbu', e.target.value)
                            }
                          />
                        </FormItem>
                      </Col>
                      <Col xs={24} sm={24} md={8} lg={8}>
                        <FormItem
                          label={
                            <span className={`${styles.card_title}`}>SBG</span>
                          }
                          name="sbg"
                          rules={[
                            {
                              required: false,
                              message: 'This is a required field'
                            }
                          ]}
                          className={`${styles.select_styles}`}
                        >
                          <Input
                            disabled
                            placeholder="SBG (from selected BU)"
                            className={`${styles.margin_Top}`}
                            style={{ marginBottom: '15px' }}
                            onChange={(e) =>
                              handleFormDataOnChange('sbg', e.target.value)
                            }
                          />
                        </FormItem>
                      </Col>
                    </Row>
                  </div>
                </>
              )}

              {/* Conditional rendering when No is selected */}
              {formValues?.giftDeclaration === false && (
                <div
                  style={{ marginTop: '30px' }}
                  className={`${styles.card_content}`}
                >
                  <Row gutter={[16, 16]}>
                    {/* Row 1: Project Manager Name, Project Site Name */}
                    <Col xs={24} sm={24} md={12} lg={12}>
                      <FormItem
                        label={
                          <span className={`${styles.card_title}`}>
                            Project Manager Name
                          </span>
                        }
                        name="projectManagerName"
                        rules={[
                          {
                            required: false,
                            message: 'This is a required field'
                          }
                        ]}
                        className={`${styles.select_styles}`}
                      >
                        <Input
                          disabled
                          placeholder="Enter project manager name"
                          className={`${styles.margin_Top}`}
                          style={{ marginBottom: '15px' }}
                          onChange={(e) =>
                            handleFormDataOnChange(
                              'projectManagerName',
                              e.target.value
                            )
                          }
                        />
                      </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={12} lg={12}>
                      <FormItem
                        label={
                          <span className={`${styles.card_title}`}>
                            Project Site Name
                          </span>
                        }
                        name="projectSiteName"
                        rules={[
                          {
                            required: false,
                            message: 'This is a required field'
                          }
                        ]}
                        className={`${styles.select_styles}`}
                      >
                        <Input
                          disabled
                          placeholder="Enter project site name"
                          className={`${styles.margin_Top}`}
                          style={{ marginBottom: '15px' }}
                          onChange={(e) =>
                            handleFormDataOnChange(
                              'projectSiteName',
                              e.target.value
                            )
                          }
                        />
                      </FormItem>
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]}>
                    {/* Row 2: BU, SBU, SBG */}
                    <Col xs={24} sm={24} md={8} lg={8}>
                      <FormItem
                        label={
                          <span className={`${styles.card_title}`}>BU</span>
                        }
                        name="bu"
                        rules={[
                          {
                            required: false,
                            message: 'This is a required field'
                          }
                        ]}
                        className={`${styles.select_styles}`}
                      >
                        <Select
                          disabled={hasBuMasterId}
                          loading={get_bu_masterLoading}
                          showSearch
                          placeholder="Select BU"
                          className={`${styles.margin_Top}`}
                          style={{ marginBottom: '15px' }}
                          optionFilterProp="label"
                          filterOption={(input, option) =>
                            (option?.label ?? '')
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          options={buOptions}
                          onChange={(value) =>
                            handleFormDataOnChange('bu', value)
                          }
                        />
                      </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={8} lg={8}>
                      <FormItem
                        label={
                          <span className={`${styles.card_title}`}>SBU</span>
                        }
                        name="sbu"
                        rules={[
                          {
                            required: false,
                            message: 'This is a required field'
                          }
                        ]}
                        className={`${styles.select_styles}`}
                      >
                        <Input
                          disabled
                          placeholder="SBU (from selected BU)"
                          className={`${styles.margin_Top}`}
                          style={{ marginBottom: '15px' }}
                          onChange={(e) =>
                            handleFormDataOnChange('sbu', e.target.value)
                          }
                        />
                      </FormItem>
                    </Col>
                    <Col xs={24} sm={24} md={8} lg={8}>
                      <FormItem
                        label={
                          <span className={`${styles.card_title}`}>SBG</span>
                        }
                        name="sbg"
                        rules={[
                          {
                            required: false,
                            message: 'This is a required field'
                          }
                        ]}
                        className={`${styles.select_styles}`}
                      >
                        <Input
                          disabled
                          placeholder="SBG (from selected BU)"
                          className={`${styles.margin_Top}`}
                          style={{ marginBottom: '15px' }}
                          onChange={(e) =>
                            handleFormDataOnChange('sbg', e.target.value)
                          }
                        />
                      </FormItem>
                    </Col>
                  </Row>
                </div>
              )}
            </>
          </Card>
        </div>
        <Row>
          <Button
            className={`${styles.cancel_button}`}
            htmlType="submit"
            size="middle"
            onClick={() => history.push('/declaration-form')}
          >
            Back
          </Button>
          <Button
            loading={submit_declarationLoading}
            className={`${styles.submit_button}`}
            htmlType="submit"
            size="middle"
            type="primary"
          >
            Submit
          </Button>
        </Row>
      </Form>
    </div>
  );
};

export default CreateDeclarationFormPage;
